import { mapAtom } from '../../atoms/map/map'
import { findLayer } from '../utils/findLayer'

export const clearOrderFeatures = () => {
  const map = mapAtom.map
  const layer = findLayer(map, 'order')

  layer.getSource()?.clear()
}
